import { instance2 } from "App/constants"
import { makeStyles } from "@material-ui/core/styles"
import {
  DEFAULT_BOX_SHADOW,
  PRIMARY_BACKGROUND,
  instance1,
} from "App/constants"
import {
  isNull,
  oneMonthBeforeToday,
  today,
  toDayIndo,
} from "App/utils/helpers"
import React, { useEffect, useState } from "react"
import { Grid } from "@material-ui/core"
import { InputOptionMaster } from "App/Component/ui"
import { lastOfDay, startOfDay } from "utils/dates"
import { messageError } from "utils/all"

export const urlAddBookingAntrian =
  "/registration/registration/createbooking_onsite"
export const urlGetBookingAntrian =
  "/registration/registration/listbooking_onsite"
export const urlGetBookingAntrianExport =
  "/registration/registration/listbooking_onsite_export"
export const urlFilterInternal = "/patient/listpatientsfilter_regrj"
export const urlFilterExternal = "/patient/listpatientsfilter_external"
export const urlGetPerusahaan = "/company/listcompany_antk"
export const urlGetDokter = "/doctor/listdoctor_antk"
export const urlGetScheduleDokter = "/doctor/listscheduledoctor_id_antk"
export const urlCancelBookingJKN =
  "/registration/registration/cancelbooking-jkn-dari-onsite"
export const urlGetStatusJKN =
  "/api/v1/rsannisa/ws/bpjs/antrean-per-kode-booking"
export const urlUpdateWaktuAntrean = "/api/v1/rsannisa/ws/bpjs/antrean/batal"

export const KODE_MOBILE = 1
export const KODE_ONSIDE = 2
export const KODE_JKN = 3

export const RESET_STATE_BOOKING_ANTRIAN = {
  date: "",
  rm_id: "",
  label_rm: "Pilih RM",
  name: "",
  nik: "",
  id: "",
  mobile_phone: "",

  insurance_id: null,
  insurance_name: "Pilih Asuransi",
  company_id: null,
  company_name: "Pilih Perusahaan",

  initial: "",
  antrianno: "",

  insurance_no: "",
  norujukan: "",
  nokontrol: "",
  doctor_id: null,
  doctor_name: "Pilih Dokter",
  schedule_doctor_id: "",
  remark: "-",
  jenisrm: 2,
  pasien_prioritas: false,

  asal: "",

  keterangan_batal_jkn: "",

  id_booking_form: "", // sama dengan id. hanya saja ini tambahan biar bisa dibaca component <ModalCancelBooking/>
}

export const RESET_STATE_FORM_FILTER = {
  name: "",
  idbooking: "",
  first_date: oneMonthBeforeToday(false),
  finish_date: today(),
  schedule_doctor_id: "",
  insurance_id: "",
  insurance_name: "Pilih Asuransi",
  status: 0,
  status_booking: "0",
  status_rm: "0",
  mobileonsite: 0,
  doctor_id: null,
  doctor_name: "Pilih Dokter",
  pages: 1,
  limit: 10,
}

export const statusBookingList = [
  {
    value: "0",
    label: "Semua",
  },
  {
    value: "1",
    label: "Aktif",
  },
  {
    value: "2",
    label: "Tidak Aktif",
  },
]

export const statusRmList = [
  {
    value: "0",
    label: "Semua",
  },
  {
    value: "1",
    label: "Aktif",
  },
  {
    value: "2",
    label: "Pending",
  },
]

export const validation = (formData) => {
  if (formData.rm_id === "") {
    return {
      state: false,
      message: "RM tidak boleh kosong",
    }
  } else if (isNull(formData.mobile_phone)) {
    return {
      state: false,
      message: "No HP tidak boleh kosong",
    }
  } else if (isNull(formData.insurance_id)) {
    return {
      state: false,
      message: "Asuransi tidak boleh kosong",
    }
  } else if (isNull(formData.company_id)) {
    return {
      state: false,
      message: "Perusahaan tidak boleh kosong",
    }
  } else if (isNull(formData.schedule_doctor_id)) {
    return {
      state: false,
      message: "Schedule Dokter tidak boleh kosong",
    }
  } else if (isNull(formData.date)) {
    return {
      state: false,
      message: "Tanggal tidak boleh kosong",
    }
  } else {
    return {
      state: true,
    }
  }
}

export const STYLE_MASTER_GUDANG_UTAMA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const getByFilterBookingAntrian = async (formFilter, pages, limit) => {
  try {
    const scheduleIdAndDay = formFilter.schedule_doctor_id.split("--")
    const api = await instance2.get(urlGetBookingAntrian, {
      headers: {
        schedule_doctor_id: scheduleIdAndDay[0],
        name: formFilter.name,
        insurance_id: isNull(formFilter.insurance_id)
          ? ""
          : formFilter.insurance_id,
        idbooking: formFilter.idbooking,
        status_booking: formFilter.status_booking,
        status_rm: formFilter.status_rm,
        doctor_id: isNull(formFilter.doctor_id) ? "" : formFilter.doctor_id,
        mobileonsite: formFilter.mobileonsite,
        first_date: startOfDay(formFilter.first_date),
        finish_date: lastOfDay(formFilter.finish_date),
        status: formFilter.status,
        pages,
        limit,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterBookingAntrianExport = async (formFilter) => {
  try {
    const scheduleIdAndDay = formFilter.schedule_doctor_id.split("--")
    const api = await instance2.get(urlGetBookingAntrianExport, {
      headers: {
        schedule_doctor_id: scheduleIdAndDay[0],
        name: formFilter.name,
        insurance_id: isNull(formFilter.insurance_id)
          ? ""
          : formFilter.insurance_id,
        idbooking: formFilter.idbooking,
        status_booking: formFilter.status_booking,
        status_rm: formFilter.status_rm,
        doctor_id: isNull(formFilter.doctor_id) ? "" : formFilter.doctor_id,
        mobileonsite: formFilter.mobileonsite,
        first_date: startOfDay(formFilter.first_date),
        finish_date: lastOfDay(formFilter.finish_date),
        status: formFilter.status,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID BOOKING",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "rm_id",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "status_booking",
    disablePadding: true,
    label: "STATUS BOOKING",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: true,
    label: "STATUS REGISTRASI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_rm",
    disablePadding: true,
    label: "STATUS RM",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL ANTRIAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "initial",
    disablePadding: false,
    label: "ANTRIAN",
    align: "left",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "booking_from",
    disablePadding: true,
    label: "ASAL BOOKING",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "insurace_name",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    sort: false,
    minWidth: "130px",
  },
  {
    id: "mobile_phone",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    sort: false,
    minWidth: "130px",
  },
  {
    id: "phone_number",
    disablePadding: false,
    label: "TLP",
    align: "left",
    sort: false,
    minWidth: "130px",
  },
  {
    id: "doctor_name",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const useScehuldeDokter = (idDokter) => {
  const DEFAULT_OPTION = [
    {
      label: "Pilih",
      value: "",
    },
  ]

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      if (!isNull(idDokter)) {
        const api = await instance1.get(urlGetScheduleDokter, {
          headers: {
            iddoctor: idDokter,
          },
        })
        const res = api.data
        return res.body
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      const res = await get()
      if (res) {
        const data = [
          {
            value: "",
            label: "Pilih",
          },
        ]

        res.map((item) => {
          return data.push({
            value: `${item.id}--${item.day}`,
            label: `${toDayIndo(item.day)} ${item.time_start} - ${
              item.time_finish
            }`,
          })
        })

        setState(data)
      }
    })()
  }, [idDokter]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const dayToInt = (day) => {
  const lowerDay = day.toLowerCase()

  if (lowerDay === "monday") {
    return 1
  } else if (lowerDay === "tuesday") {
    return 2
  } else if (lowerDay === "wednesday") {
    return 3
  } else if (lowerDay === "thursday") {
    return 4
  } else if (lowerDay === "friday") {
    return 5
  } else if (lowerDay === "saturday") {
    return 6
  } else if (lowerDay === "sunday") {
    return 0
  }
}

export const DoctorAndScheduleForm = ({
  handleChange,
  formData,
  dokter,
  scheduleDokter,
  setFormData,
}) => {
  return (
    <>
      <Grid item sm={4}>
        <InputOptionMaster
          name="doctor_id"
          label="DOKTER"
          id="doctor_id"
          withSearch={true}
          labelValue={formData.doctor_name}
          data={dokter}
          value={formData.doctor_id}
          error={true}
          message={messageError.required}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                doctor_id: null,
                doctor_name: "Pilih Dokter",
              })
            } else {
              setFormData({
                ...formData,
                doctor_id: e.value,
                doctor_name: e.label,
              })
            }
          }}
        />
      </Grid>
      <Grid item sm={4}>
        <InputOptionMaster
          name="schedule_doctor_id"
          label="SCHEDULE DOKTER"
          id="schedule_doctor_id"
          withSearch={false}
          needParse={false}
          data={scheduleDokter}
          value={formData.schedule_doctor_id}
          onChange={handleChange("schedule_doctor_id")}
          error={true}
          message={messageError.required}
        />
      </Grid>
    </>
  )
}

export const ANTREAN_JKN_STATUS = {
  SELESAI_DILAYANI: "Selesai dilayani",
  BELUM_DILAYANI: "Belum dilayani",
  BATAL: "Batal",
}
